import { MbProductEffects } from './mb-product.effect'

export const effects: any[] = [
  MbProductEffects
]

export * from './mb-product.effect'
